import ProducerDetailsCounters from './ProducerDetailsCounters';

export default ProducerDetailsCounters;
